// This file is auto-generated by 'yarn sync' - do not edit manually
// Generated on: 2026-06-02T06:44:00.288Z

export const assets = {
  emails: {
    'no-uploads': {
      'memory-icon-128x128.png':
        'https://static.timely-cdn.com/emails/no-uploads/memory-icon-128x128-001d9a608d38.png',
    },
    'timely-logo-256x256.png':
      'https://static.timely-cdn.com/emails/timely-logo-256x256-f943f3be59ff.png',
    'timely-mark-76x120.png':
      'https://static.timely-cdn.com/emails/timely-mark-76x120-3dbc1c17acb6.png',
  },
  icons: {
    'jira_128.png': 'https://static.timely-cdn.com/icons/jira_128-01b1b72ba1f0.png',
    'jira_256.png': 'https://static.timely-cdn.com/icons/jira_256-54b5f7727653.png',
  },
  onboarding: {
    'AutoSheet_GIF_3_shortie_3.mp4':
      'https://static.timely-cdn.com/onboarding/AutoSheet_GIF_3_shortie_3-c8e6d80313c1.mp4',
  },
  'timely-ios-1024x1024@1x.png':
    'https://static.timely-cdn.com/timely-ios-1024x1024@1x-00a4bfa9c520.png',
} as const;

export default assets;
